import emojiRegex from "emoji-regex"

export const UNTITLED_TAB_NAME = "Untitled"

const tabEmojiRegex = emojiRegex()

/** Returns the first emoji in a tab name, or an empty string when there is none. */
export function extractEmoji(name: string) {
    return name.match(tabEmojiRegex)?.[0] ?? ""
}

/** Returns the user-visible text portion of a tab name. */
export function tabNameWithoutEmoji(name: string) {
    return name.replace(tabEmojiRegex, "").trim()
}

/** Returns a stable label for blank and emoji-only tab names. */
export function getTabDisplayName(name: string) {
    return tabNameWithoutEmoji(name) || UNTITLED_TAB_NAME
}

export function isUntitledTabName(name: string) {
    return !tabNameWithoutEmoji(name)
}
